import React from "react";
import { Box } from "@mui/material";
import balance from "../../../assets/home/sidebar/balance.png";
import { Swiper } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Pagination } from "swiper";

const LeaveBalance = () => {
  return (
    <>
      <Box className="slidebar-container  br-16" marginTop="20px">
        <Box
          className="balance-container d-flex"
          gap="20px"
          paddingBottom="10px"
        >
          <div className="balance-logo flex-center-center">
            <img src={balance} />
          </div>
          <h2>Leave Balance</h2>
        </Box>
        <Swiper
          spaceBetween={30}
          centeredSlides={true}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          modules={[Autoplay, Pagination]}
          className="mySwiper"
        ></Swiper>
        <div className="button-blnc flex-center-center">
          <button className="balance-button">Request Time Off</button>
        </div>
      </Box>
    </>
  );
};

export default LeaveBalance;
